<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1> G. H. Raisoni Memorial Madhya Pradesh State Junior (U-19) Ranking Badminton Tournament 2026
                        held at Khargone</h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png">
    </div>
</section>
<section class="section-lg">
    <div class="container">
        <div class="sec-title">
            <h2><span> G. H. Raisoni Memorial Madhya Pradesh State Junior (U-19) Ranking Badminton Tournament 2026 held
                    at Khargone</span></h2>
        </div>
        <ul id="myeventTab" role="tablist" class="nav nav-pills justify-content-center flex-row">
            <li class="nav-item"><a id="photos-tab" data-bs-toggle="tab" href="#photos" role="tab"
                    aria-controls="photos" aria-selected="true" class="nav-link text-center active">Photos</a></li>
            <li class="nav-item"><a id="media-tab" data-bs-toggle="tab" href="#media" role="tab" aria-controls="media"
                    aria-selected="false" class="nav-link text-center">media</a></li>
            <li class="nav-item"><a id="report-tab" data-bs-toggle="tab" href="#report" role="tab"
                    aria-controls="report" aria-selected="false" class="nav-link text-center">Report</a></li>
        </ul>
        <div id="myTabContent" class="tab-content mt-5">
            <div id="photos" role="tabpanel" aria-labelledby="photos-tab" class="tab-pane fade show active">
                <div data-aos="zoom-in" class="sec-title text-center mb-5 aos-init aos-animate">
                    <h2>Photos </h2>
                </div>
                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-1.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-2.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-3.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-4.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-5.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-6.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-7.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-8.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-8.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-8.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="media" role="tab-pane1" aria-labelledby="media-tab" class="tab-pane fade">
                <div data-aos="zoom-in" class="sec-title text-center mb-5 aos-init aos-animate">
                    <h2>Media</h2>
                </div>

                <div class="lightBox--gallery">
                    <ul class="list-unstyled lightgallery justify-content-center row row-cols-1 row-cols-md-4">
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-1.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-1.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-1.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-2.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-2.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-2.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-3.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-3.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-3.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-4.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-4.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-4.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-5.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-5.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-5.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-6.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-6.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-6.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                        <li class="col"
                            data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-7.webp"
                            data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-7.webp">
                            <a href="Javascript:void(0);">
                                <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-media-7.webp"
                                    alt="Amravati District Badminton Championship 2026 | GHRSCF" title="GHRSCF"
                                    class="img-fluid" />
                                <div class="light-gallery-poster">
                                    <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png"
                                        alt="GHRSCF" />
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div id="report" role="tab-pane1" aria-labelledby="report-tab" class="tab-pane fade">
                <div data-aos="zoom-in" class="sec-title text-center mb-5 aos-init aos-animate">
                    <h2>Report</h2>
                </div>
                <div class="row row-cols-1 row-cols-md-2">
                    <div class="col-lg-6">
                        <div class="gall-ery">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                                        <h4 class="fw-bold">Khargone Draws With Results</h4>
                                    </div>
                                </div>

                            </div>
                            <iframe
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-draws-results.pdf"
                                width="100% " height="500px" frameborder="0"></iframe>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="gall-ery">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                                        <h4 class="fw-bold">Khargone Overview</h4>
                                    </div>
                                </div>

                            </div>
                            <iframe
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-overview.pdf"
                                width="100% " height="500px" frameborder="0"></iframe>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="gall-ery">
                            <div class="row">
                                <div class="col-md-8">
                                    <div class="widget_title inner-title gall-sys shadow-text-sm">
                                        <h4 class="fw-bold">Khargone Winners</h4>
                                    </div>
                                </div>

                            </div>
                            <iframe
                                src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/khargone/khargone-winners.pdf"
                                width="100% " height="500px" frameborder="0"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
